'use client';

import { useState, ChangeEvent } from 'react';

const CustomCheckbox = ({ isChecked, onChange }: { isChecked: boolean, onChange: (e: ChangeEvent<HTMLInputElement>) => void }) => (
  <div className="flex items-center">
    <input
      id="data-consent"
      type="checkbox"
      name="consent"
      checked={isChecked}
      onChange={onChange}
      className="
                h-5 w-5 rounded border-2 border-gray-400 cursor-pointer transition-all duration-200 ease-in-out
                checked:bg-[#FF7C22] checked:border-[#FF7C22] checked:hover:bg-orange-700
                focus:ring-2 focus:ring-offset-2 focus:ring-[#FF7C22] focus:ring-offset-white
                appearance-none
            "
      style={{
        backgroundImage: isChecked
          ? `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23ffffff' stroke-width='3' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='20 6 9 17 4 12'%3E%3C/polyline%3E%3C/svg%3E")`
          : 'none',
        backgroundSize: '80%',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
      }}
    />
    <label htmlFor="data-consent" className="ml-3 text-sm text-gray-700 cursor-pointer">
      Я соглашаюсь с <a href="#" className="text-[#FF7C22] hover:underline">обработкой персональных данных</a>
    </label>
  </div>
);

export default function ContactPage() {
  const [formName, setFormName] = useState('');
  const [formEmail, setFormEmail] = useState('');
  const [formPhone, setFormPhone] = useState('');
  const [formMessage, setFormMessage] = useState('');
  const [isConsentChecked, setIsConsentChecked] = useState(false);
  const [formStatus, setFormStatus] = useState('');

  const handleSubmit = async (e: { preventDefault: () => void }) => {
    e.preventDefault();

    if (!isConsentChecked) {
      setFormStatus('Пожалуйста, дайте согласие на обработку персональных данных.');
      return;
    }

    setFormStatus('Отправка...');
    const apiUrl = `${process.env.NEXT_PUBLIC_STRAPI_API_URL}/api/contact-requests`;

    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          data: {
            formName: 'Контакты', 
            name: formName,           
            email: formEmail,
            phone: formPhone,
            message: formMessage,
            consent: isConsentChecked,
          },
        }),

      });

      if (response.ok) {
        setFormStatus('Ваша заявка успешно отправлена!');
        setFormName('');
        setFormEmail('');
        setFormPhone('');
        setFormMessage('');
        setIsConsentChecked(false);
      } else {
        const errorData = await response.json();
        const errorMessage = errorData.error?.message || 'Произошла неизвестная ошибка при отправке.';
        setFormStatus(`Произошла ошибка: ${errorMessage}`);
        console.error('Ошибка:', errorData);
      }
    } catch (error) {
      setFormStatus('Ошибка сети. Пожалуйста, попробуйте снова.');
      console.error('Ошибка:', error);
    }
  };

  return (
    <main className="min-h-screen bg-[#f6f8ff] text-[#0f172a] font-[Inter,system-ui,-apple-system,Segoe UI,Roboto,Arial,sans-serif]">
      <section
        className="relative flex items-center justify-center min-h-[60vh] text-white overflow-hidden py-10 md:py-20 text-center pt-20"
        style={{
          background: `radial-gradient(900px 380px at 15% -10%, #2e5ec5 0%, rgba(46,94,197,.6) 30%, transparent 60%), radial-gradient(1200px 500px at 90% 10%, #0b1f56 0%, #071b42 60%, #05142c 100%)`,
        }}
      >
        <div className="max-w-6xl mx-auto px-6">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold mt-2 mb-4 leading-tight">Свяжитесь с нами</h1>
          <p className="text-lg text-white/80 max-w-lg mx-auto">
            Оставьте свои контактные данные, и мы подготовим для вас индивидуальное предложение.
          </p>
        </div>
      </section>

      <section className="bg-[#f6f8ff] py-16 md:py-24">
        <div className="mx-auto max-w-6xl px-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-10 lg:gap-16">
            <div className="bg-white p-8 sm:p-12 rounded-3xl shadow-[0_20px_50px_rgba(2,6,23,.1)] border border-[#e5e7eb]">
              <h3 className="text-2xl font-bold text-[#003B9B]">Отправить сообщение</h3>
              <p className="mt-2 text-base text-gray-600">
                Мы ответим на ваш запрос в течение одного рабочего дня.
              </p>

              <form onSubmit={handleSubmit} className="mt-8 space-y-6">
                <div>
                  <label htmlFor="contact-name" className="block text-sm text-gray-700 font-medium mb-1">Имя</label>
                  <input
                    id="contact-name"
                    placeholder="Как к вам обращаться"
                    value={formName}
                    onChange={(e) => setFormName(e.target.value)}
                    className="w-full px-4 py-3 border border-[#d1d5db] rounded-xl focus:ring-2 focus:ring-[#FF7C22] focus:border-transparent transition-all duration-200"
                    required
                  />
                </div>
                <div>
                  <label htmlFor="contact-email" className="block text-sm text-gray-700 font-medium mb-1">Email</label>
                  <input
                    id="contact-email"
                    type="email"
                    placeholder="example@interim.ru"
                    value={formEmail}
                    onChange={(e) => setFormEmail(e.target.value)}
                    className="w-full px-4 py-3 border border-[#d1d5db] rounded-xl focus:ring-2 focus:ring-[#FF7C22] focus:border-transparent transition-all duration-200"
                    required
                  />
                </div>
                <div>
                  <label htmlFor="contact-phone" className="block text-sm text-gray-700 font-medium mb-1">Телефон</label>
                  <input
                    id="contact-phone"
                    type="tel"
                    placeholder="+7 (___) ___‑__‑__"
                    value={formPhone}
                    onChange={(e) => setFormPhone(e.target.value)}
                    className="w-full px-4 py-3 border border-[#d1d5db] rounded-xl focus:ring-2 focus:ring-[#FF7C22] focus:border-transparent transition-all duration-200"
                    required
                  />
                </div>
                <div>
                  <label htmlFor="contact-message" className="block text-sm text-gray-700 font-medium mb-1">Сообщение</label>
                  <textarea
                    id="contact-message"
                    rows={4}
                    placeholder="Ваше сообщение..."
                    value={formMessage}
                    onChange={(e) => setFormMessage(e.target.value)}
                    className="w-full px-4 py-3 border border-[#d1d5db] rounded-xl focus:ring-2 focus:ring-[#FF7C22] focus:border-transparent transition-all duration-200 resize-y"
                    required
                  />
                </div>

                <div className="pt-2">
                  <CustomCheckbox
                    isChecked={isConsentChecked}
                    onChange={(e) => setIsConsentChecked(e.target.checked)}
                  />
                </div>

                <div className="mt-8 relative">
                  <button
                    type="submit"
                    className="w-full bg-[#FF7C22] text-white rounded-xl font-bold py-4 px-5 transition-colors duration-300 ease-in-out hover:bg-orange-700 focus:outline-none focus:ring-4 focus:ring-[#FF7C22]/50"
                  >
                    Отправить заявку
                  </button>
                  {formStatus && (
                    <p className="mt-4 text-sm text-center text-slate-500">
                      {formStatus}
                    </p>
                  )}
                </div>
              </form>
            </div>

            <div className="bg-[#003B9B] p-8 sm:p-12 rounded-3xl shadow-[0_20px_50px_rgba(2,6,23,.1)] flex flex-col justify-between">
              <div>
                <h3 className="text-2xl font-bold text-white">Наши контакты</h3>
                <p className="mt-2 text-base text-gray-300">
                  Мы готовы ответить на все ваши вопросы.
                </p>
                <div className="mt-8 space-y-6">
                  <div className="flex items-center space-x-4">
                    <div className="flex items-center justify-center w-12 h-12 rounded-full bg-[#FF7C22] text-white shadow-lg flex-shrink-0">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></svg>
                    </div>
                    <div>
                      <p className="text-white text-lg font-semibold">Телефон</p>
                      <a href="tel:+74951234567" className="text-gray-300 hover:text-white hover:underline transition-colors duration-200">+7 (963) 703-09-20</a>
                    </div>
                  </div>

                  <div className="flex items-center space-x-4">
                    <div className="flex items-center justify-center w-12 h-12 rounded-full bg-[#FF7C22] text-white shadow-lg flex-shrink-0">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect width="20" height="16" x="2" y="4" rx="2"></rect><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"></path></svg>
                    </div>
                    <div>
                      <p className="text-white text-lg font-semibold">Email</p>
                      <a href="mailto:info@interimjob.ru" className="text-gray-300 hover:text-white hover:underline transition-colors duration-200">info@interimjob.ru</a>
                    </div>
                  </div>

                  <div className="flex items-start space-x-4">
                    <div className="flex items-center justify-center w-12 h-12 rounded-full bg-[#FF7C22] text-white shadow-lg flex-shrink-0 mt-1">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"></path><circle cx="12" cy="10" r="3"></circle></svg>
                    </div>
                    <div>
                      <p className="text-white text-lg font-semibold">Наш адрес</p>
                      <p className="text-gray-300 text-sm mt-1">
                        г. Грозный, ул. Лорсанова, д. 4, офис 6
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="mt-12 text-center text-base text-gray-400">
                <p>Рабочие часы: Пн-Пт, с 9:00 до 18:00</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}